import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const useYourBids = (type:string) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const panel = Number(queryParams.get("panel")) ;
  const page = Number(queryParams.get("page")) || 1;
  const limit = Number(queryParams.get("limit")) || 10;
  let urlKey = `${t("bid-property-list-api")}?page=${page}&limit=${limit}`;
  
  const { data, refetch, isLoading, isPlaceholderData } = useQuery({
    queryKey: [`Your-Bids`, page, limit],
    queryFn: async () => {
      const res = await axios.get(urlKey);
      if (Number(page) === 1) {
        localStorage.setItem("BidPropertyTotal", res.data.data[0]?.full_count);
      }
      return res.data;
    },
    placeholderData: (previousData) => previousData, // Identity function
    enabled: panel === 1 && window.innerWidth >= 768 && type === 'agent'
  });

  return { data: data?.data, refetch, isLoading, isPlaceholderData };
};
